import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function initHistoryPin(selector = '.js-historyTimeline') {
    document.querySelectorAll(selector).forEach(section => {
        const items = section.querySelectorAll('.historyTimeline__item');
        const lineProgress = section.querySelector('.historyTimeline__lineProgress');
        const itemsWrapper = section.querySelector('.historyTimeline__items');

        if (lineProgress && itemsWrapper) {
            gsap.to(lineProgress, {
                height: '100%',
                ease: 'none',
                scrollTrigger: {
                    trigger: itemsWrapper,
                    start: 'top center',
                    end: 'bottom center',
                    scrub: true,
                },
            });
        }

        items.forEach(item => {
            const yearWrap = item.querySelector('.historyTimeline__yearWrap');
            const content = item.querySelector('.historyTimeline__content');
            const dot = item.querySelector('.historyTimeline__dot');
            const media = item.querySelector('.historyTimeline__media');
            const isEven = item.classList.contains('historyTimeline__item--even');

            if (dot) gsap.set(dot, { xPercent: -50, rotation: 45, scale: 0 });
            if (yearWrap) gsap.set(yearWrap, { opacity: 0, x: isEven ? 32 : -32 });
            if (content) gsap.set(content, { opacity: 0, y: 32 });

            const trigger = { trigger: item, start: 'top 82%' };

            if (dot) {
                ScrollTrigger.create({
                    ...trigger,
                    onEnter: () => gsap.to(dot, { scale: 1, duration: 0.7, ease: 'back.out(1.7)' }),
                    onLeaveBack: () => gsap.to(dot, { scale: 0, duration: 0.4 }),
                });
            }

            if (yearWrap) {
                ScrollTrigger.create({
                    ...trigger,
                    onEnter: () => gsap.to(yearWrap, { opacity: 1, x: 0, duration: 0.7, ease: 'power2.out' }),
                    onLeaveBack: () => gsap.to(yearWrap, { opacity: 0, x: isEven ? 32 : -32, duration: 0.4 }),
                });
            }

            if (content) {
                ScrollTrigger.create({
                    ...trigger,
                    onEnter: () => gsap.to(content, { opacity: 1, y: 0, duration: 0.7, delay: 0.15, ease: 'power2.out' }),
                    onLeaveBack: () => gsap.to(content, { opacity: 0, y: 32, duration: 0.4 }),
                });
            }

            if (media) {
                if (window.matchMedia('(min-width: 1024px)').matches) {
                    gsap.set(media, { opacity: 0, scale: 0.95, xPercent: -50, yPercent: -50 });

                    item.addEventListener('mouseenter', () => {
                        gsap.killTweensOf(media);
                        item.style.zIndex = '50';
                        gsap.to(media, { opacity: 1, scale: 1, duration: 0.5, ease: 'power2.out' });
                    });
                    item.addEventListener('mouseleave', () => {
                        gsap.killTweensOf(media);
                        gsap.to(media, {
                            opacity: 0, scale: 0.95, duration: 0.3, ease: 'power2.in',
                            onComplete: () => { item.style.zIndex = ''; },
                        });
                    });
                }
            }
        });

        const skipBtn = section.querySelector('.js-historySkip');
        if (skipBtn) {
            skipBtn.addEventListener('click', () => {
                const rect = section.getBoundingClientRect();
                window.scrollTo({ top: window.scrollY + rect.bottom, behavior: 'smooth' });
            });
        }
    });
}
